import React from 'react';

const SmallSpinner = () => {
  return (
    <div>
      <div className="h-screen bg-white">
      <div className="flex justify-center items-center  ">
        
        <img className="h-16 w-16" src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif" alt=""/>
      </div>
      </div>
    </div>
  );
};

export default SmallSpinner;